// Médias — effet zoom
const CLIP_SELECTORS =
  'figure, img, .wp-block-image, [class*="Block-media"], [class*="Block-img"], [class*="Block-image"], [class*="Block-picture"]';

// Cards "unité entière" — révélées d'un bloc, en décalé entre elles.
// Taguées AVANT le passage médias pour que l'image de la card ne prenne pas
// son propre zoom (sinon animation interne image/texte au lieu de la card
// entière). Leurs enfants (titre, image, prix, CTA…) sont skippés par les
// passages suivants (dans un [data-gk-reveal] non-wrapper).
const CARD_UNIT_SELECTORS =
  '.Card, .PricingBlock-card, .HighLights-keyNumber, [class*="-item "], [class$="-item"]';

// Blocs, boutons — effet up
const UP_SELECTORS =
  'p, a[class*="btn"], a[class*="Btn"], button, .Button, [class*="Button"], [class*="btn--"], [class*="-cta"], .wp-block-button, .wp-block-button__link, footer [class*="-topBlock"], footer [class*="-bottomBlock"], footer [class*="-copyright"], .TopIntro-breadcrumbs, .wpcf7-form p, .wpcf7-form-control-wrap, .gfield';

// Titres + items de liste — hors blocs déjà révélés
const CONTENT_SELECTORS = "h1, h2, h3, h4, h5, h6, li";

// Wrappers avec fond de couleur — révélés en premier, enfants autorisés
const WRAPPER_SELECTORS =
  ".PageWrapper.-themeLight, .PageWrapper.-themeDark, .PageWrapper.-themeAccent, .PageWrapper.-backgroundImage";

// Conteneurs exclus
const EXCLUDE_SELECTOR =
  'header, nav, #gk-overlay, .gk-overlay, .splide__slide, .splide__pagination, .splide__pagination__page, .splide__arrows, .splide__arrow, [role="tablist"], [role="menubar"], .AccordionTabsBlock-panel, .AccordionTabsBlock-content, .-parallaxItem';

const ROW_TOLERANCE = 40;

let _revealObserver = null;

// Ordonne par ligne (haut→bas) puis par colonne (gauche→droite)
const sortByPosition = (items) => {
  const withRects = items
    .map((el) => ({ el, rect: el.getBoundingClientRect() }))
    .sort((a, b) => a.rect.top - b.rect.top);

  const rows = [];

  withRects.forEach((item) => {
    const row = rows.find(
      (r) => Math.abs(r.top - item.rect.top) < ROW_TOLERANCE,
    );
    if (row) {
      row.items.push(item);
    } else {
      rows.push({ top: item.rect.top, items: [item] });
    }
  });

  rows.forEach((row) => row.items.sort((a, b) => a.rect.left - b.rect.left));
  return rows.flatMap((row) => row.items.map((item) => item.el));
};

const initReveal = () => {
  // ── Pré-pass : TopIntro — ordre d'entrée explicite
  //    Géré avant tous les autres passes pour maîtriser les delays d'animation de page
  const topIntro = document.querySelector(".TopIntro");
  if (topIntro) {
    const topIntroPicture = topIntro.querySelector(".TopIntro-picture");
    const hasImage = !!(
      topIntroPicture && topIntroPicture.querySelector("img")
    );

    if (!hasImage) {
      // Sans image : le fond coloré du TopIntro slide in en premier
      topIntro.setAttribute("data-gk-reveal", "up");
      topIntro.setAttribute("data-gk-reveal-delay", "0");
      topIntro.dataset.gkRevealWrapper = "1";
    } else {
      // Avec image : l'image zoom-in en premier
      const img = topIntroPicture.querySelector("img");
      if (img) {
        img.setAttribute("data-gk-reveal", "zoom");
        img.setAttribute("data-gk-reveal-delay", "0");
      }
    }

    // Delays en cascade : H1 → breadcrumb → subtitle / meta / content
    const d = hasImage ? 120 : 80;

    topIntro.querySelectorAll("h1").forEach((el) => {
      el.setAttribute("data-gk-reveal", "up");
      el.setAttribute("data-gk-reveal-delay", String(d));
    });

    topIntro.querySelectorAll(".TopIntro-breadcrumbs").forEach((el) => {
      el.setAttribute("data-gk-reveal", "up");
      el.setAttribute("data-gk-reveal-delay", String(d + 80));
    });

    topIntro
      .querySelectorAll(".TopIntro-subtitle, .TopIntro-meta, .TopIntro-content")
      .forEach((el, i) => {
        el.setAttribute("data-gk-reveal", "up");
        el.setAttribute("data-gk-reveal-delay", String(d + 160 + i * 60));
      });
  }

  // ── Passage 0 : wrappers colorés
  //    Révélés en premier ; leurs enfants peuvent AUSSI se révéler (data-gk-reveal-wrapper)
  //    Skip si contient un stack parallax (transform/clip-path briserait sticky + z-index)
  document.querySelectorAll(WRAPPER_SELECTORS).forEach((el) => {
    if (el.closest(EXCLUDE_SELECTOR)) return;
    if (el.hasAttribute("data-gk-reveal")) return;
    if (el.querySelector(".-parallaxItem")) return;
    el.setAttribute("data-gk-reveal", "up");
    el.dataset.gkRevealWrapper = "1";
  });

  // ── Passage 0.5 : cards "unité entière" — AVANT les médias
  //    Ainsi l'image contenue dans une card est absorbée dans l'unité (le
  //    passage médias la skip car un ancêtre porte déjà data-gk-reveal) :
  //    la card apparaît d'un bloc, sans animation interne image/texte.
  document.querySelectorAll(CARD_UNIT_SELECTORS).forEach((el) => {
    if (el.closest(EXCLUDE_SELECTOR)) return;
    if (el.hasAttribute("data-gk-reveal")) return;
    if (el.closest("[data-gk-reveal]:not([data-gk-reveal-wrapper])")) return;
    el.setAttribute("data-gk-reveal", "up");
  });

  // ── Passage 1 : médias (zoom) — skip si dans un bloc déjà révélé
  document.querySelectorAll(CLIP_SELECTORS).forEach((el) => {
    if (el.closest(EXCLUDE_SELECTOR)) return;
    if (el.hasAttribute("data-gk-reveal")) return;
    if (el.closest("[data-gk-reveal]")) return;
    el.setAttribute("data-gk-reveal", "zoom");
  });

  // ── Passage 1.5 : blockquotes — la citation avant son texte
  //    Le blockquote (porteur des guillemets décoratifs ::before) est révélé
  //    comme un tout (wrapper) ; son <p> se révèle ensuite via le décalage de
  //    base des enfants de wrapper (+300ms), donc APRÈS les guillemets.
  document.querySelectorAll("blockquote").forEach((el) => {
    if (el.closest(EXCLUDE_SELECTOR)) return;
    if (el.hasAttribute("data-gk-reveal")) return;
    if (el.closest("[data-gk-reveal]:not([data-gk-reveal-wrapper])")) return;
    el.setAttribute("data-gk-reveal", "up");
    el.dataset.gkRevealWrapper = "1";
  });

  // ── Passage 2 : blocs / boutons / cards — unité entière
  //    Skip si dans un révélé NON-wrapper ; les enfants de wrappers restent libres
  document.querySelectorAll(UP_SELECTORS).forEach((el) => {
    if (el.closest(EXCLUDE_SELECTOR)) return;
    if (el.hasAttribute("data-gk-reveal")) return;
    if (el.closest("[data-gk-reveal]:not([data-gk-reveal-wrapper])")) return;
    el.setAttribute("data-gk-reveal", "up");
  });

  // ── Passage 3 : titres + items de liste
  //    Skip si dans un bloc NON-wrapper (pas de cascade dans les cards)
  //    Les listes dans les wrappers colorés sont autorisées (via :not([data-gk-reveal-wrapper]))
  document.querySelectorAll(CONTENT_SELECTORS).forEach((el) => {
    if (el.closest(EXCLUDE_SELECTOR)) return;
    if (el.hasAttribute("data-gk-reveal")) return;
    if (el.closest("[data-gk-reveal]:not([data-gk-reveal-wrapper])")) return;
    el.setAttribute("data-gk-reveal", "up");
  });

  // ── Priorité H1 hors TopIntro : premier élément de la page (delay 0)
  document.querySelectorAll("h1[data-gk-reveal]").forEach((el) => {
    if (!el.closest(".TopIntro")) {
      el.setAttribute("data-gk-reveal-delay", "0");
    }
  });

  const elements = document.querySelectorAll("[data-gk-reveal]");

  // ── Reveal au scroll : ordre strict haut → bas
  //    Les éléments sont révélés QUAND ils entrent dans le viewport. Ceux qui
  //    entrent dans la même frame forment un « lot » : on les trie par position
  //    (haut→bas, puis gauche→droite pour une même ligne) et on les décale les
  //    uns après les autres. Résultat : un bloc n'apparaît jamais avant ceux
  //    qui le précèdent, et les éléments d'une même ligne arrivent en cascade.
  const STAGGER_STEP = 90; // ms entre deux éléments d'un même lot
  const STAGGER_MAX = 600; // décalage total max d'un lot (borne l'attente)

  let _pending = [];
  let _scheduled = false;

  const flushReveal = () => {
    _scheduled = false;
    const batch = sortByPosition(_pending);
    _pending = [];

    // Step réduit quand le lot est gros : ordre préservé, attente bornée.
    const step = Math.min(STAGGER_STEP, STAGGER_MAX / Math.max(batch.length - 1, 1));

    batch.forEach((el, index) => {
      // Un delay explicite (ex. TopIntro, galerie) est toujours respecté.
      const explicit = el.getAttribute("data-gk-reveal-delay");
      el.style.transitionDelay = `${
        explicit !== null ? Number(explicit) : Math.round(index * step)
      }ms`;
      el.classList.add("-revealed");
    });
  };

  _revealObserver = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        _pending.push(entry.target);
        obs.unobserve(entry.target);
      });
      if (_pending.length && !_scheduled) {
        _scheduled = true;
        requestAnimationFrame(flushReveal);
      }
    },
    // Déclenche quand l'élément est franchement entré dans le viewport (pas avant).
    { threshold: 0, rootMargin: "0px 0px -10% 0px" },
  );

  // Double rAF : peint l'état caché initial sans déclencher de transition
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      elements.forEach((el) => el.classList.add("-gk-ready"));
    });
  });

  // Court délai pour laisser le fondu d'entrée de page se terminer
  setTimeout(() => {
    elements.forEach((el) => _revealObserver.observe(el));
  }, 300);

  // ── Carrousels DisplayBlock — apparition des médias au scroll
  //    Les .splide__slide sont exclus du reveal standard (les clones du mode
  //    loop resteraient masqués). On révèle donc les médias de TOUTES les
  //    slides d'un coup, via une classe posée sur le conteneur observé : les
  //    clones, étant des descendants, héritent de l'effet (cf. styles.scss).
  const mediaReveals = document.querySelectorAll(".DisplayBlock.-mode-slider");
  if (mediaReveals.length) {
    mediaReveals.forEach((el) => {
      el.classList.add("-gkMediaReveal");
      // Cascade gauche → droite : index par slide réelle (hors clones loop),
      // dans l'ordre du DOM = ordre logique d'affichage. Le délai est
      // dérivé de --gk-i en CSS (cf. styles.scss), plafonné pour rester court.
      el.querySelectorAll(
        ".DisplayBlock-splide .splide__list > .splide__slide:not(.splide__slide--clone)",
      ).forEach((slide, i) => {
        slide.style.setProperty("--gk-i", String(Math.min(i, 8)));
      });
    });

    const mediaObserver = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("-gkMediaInview");
          obs.unobserve(entry.target);
        });
      },
      { threshold: 0, rootMargin: "0px 0px -10% 0px" },
    );

    // Double rAF : peint l'état masqué initial sans déclencher de transition
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        mediaReveals.forEach((el) => el.classList.add("-gk-ready"));
      });
    });

    setTimeout(() => {
      mediaReveals.forEach((el) => mediaObserver.observe(el));
    }, 400);
  }

  // ── Sliders à cartes — apparition des cartes les unes après les autres
  //    Même principe que DisplayBlock : les .splide__slide sont exclues du
  //    reveal standard (clones du mode loop). On révèle le CONTENU de chaque
  //    slide via une classe sur le conteneur ; --gk-i (index de slide) crée la
  //    cascade gauche → droite. Cf. styles _reveal.scss (.-gkSlideReveal).
  const SLIDER_CARD_SELECTORS = [
    ".ArticleBlock-splide",
    ".ClientBlock.splide",
    ".CPTBlock.splide",
    ".TeamBlock.splide",
    ".TestimonyBlock-splide",
    ".SliderBlock.splide",
    ".VideoBlock-splide",
  ].join(",");

  const sliderReveals = document.querySelectorAll(SLIDER_CARD_SELECTORS);
  if (sliderReveals.length) {
    sliderReveals.forEach((el) => {
      el.classList.add("-gkSlideReveal");
      el.querySelectorAll(
        ".splide__list > .splide__slide:not(.splide__slide--clone)",
      ).forEach((slide, i) => {
        slide.style.setProperty("--gk-i", String(Math.min(i, 8)));
      });
    });

    const sliderObserver = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const el = entry.target;
          el.classList.add("-gkSlideInview");
          obs.unobserve(el);
          // Nettoyage une fois l'apparition terminée : on retire les classes
          // pour ne pas laisser la transition de reveal écraser le hover natif
          // des cartes. (stagger max ~0.72s + durée 0.7s → marge à 1.9s)
          setTimeout(() => {
            el.classList.remove("-gkSlideReveal", "-gk-ready", "-gkSlideInview");
          }, 1900);
        });
      },
      { threshold: 0, rootMargin: "0px 0px -10% 0px" },
    );

    // Double rAF : peint l'état masqué initial sans déclencher de transition
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        sliderReveals.forEach((el) => el.classList.add("-gk-ready"));
      });
    });

    setTimeout(() => {
      sliderReveals.forEach((el) => sliderObserver.observe(el));
    }, 300);
  }
};

// ── Bfcache (bouton retour navigateur)
window.addEventListener("pageshow", (e) => {
  if (!e.persisted) return;

  document
    .querySelectorAll("[data-gk-reveal]:not(.-revealed)")
    .forEach((el) => {
      el.style.transitionDuration = "0s";
      el.style.transitionDelay = "0s";
      el.classList.add("-revealed");
    });

  requestAnimationFrame(() => {
    document.querySelectorAll("[data-gk-reveal].-revealed").forEach((el) => {
      el.style.transitionDuration = "";
      el.style.transitionDelay = "";
    });
  });
});

export { initReveal };
